import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "home",
  "title": "Прогресс в области образования",
  "lead": "Образование освещает каждый этап пути к лучшей жизни. Все дети нуждаются в доступе к образованию хорошего качества, чтобы раскрыть свой образовательный потенциал и получить более широкие преимущества от образования. Необходимо предпринять особые усилия для того, чтобы все дети и молодые люди могли в равной степени воспользоваться его преобразующей силой. Это требует достаточных ресурсов, особенно для охвата тех, кто нуждается в дополнительной поддержке."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {HighlightByTheme, IndexHero, LandingButton, LandingText, PageLink, RelatedContent, ThemeLinks} = _components;
  if (!HighlightByTheme) _missingMdxReference("HighlightByTheme", true);
  if (!IndexHero) _missingMdxReference("IndexHero", true);
  if (!LandingButton) _missingMdxReference("LandingButton", true);
  if (!LandingText) _missingMdxReference("LandingText", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedContent) _missingMdxReference("RelatedContent", true);
  if (!ThemeLinks) _missingMdxReference("ThemeLinks", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(IndexHero, {
      children: [_jsx(_components.h1, {
        id: "scope",
        children: "SCOPE"
      }), _jsxs(_components.p, {
        children: ["Образование освещает каждый этап пути к лучшей жизни. Все дети нуждаются в ", _jsx(HighlightByTheme, {
          theme: "access",
          children: "доступе "
        }), " к образованию хорошего", _jsx(HighlightByTheme, {
          theme: "quality",
          children: "качества"
        }), ", чтобы раскрыть свой", _jsx(HighlightByTheme, {
          theme: "learning",
          children: "образовательный "
        }), " потенциал и получить более широкие преимущества от образования. Необходимо предпринять особые усилия для того, чтобы все дети и молодые люди могли ", _jsx(HighlightByTheme, {
          theme: "equity",
          children: " в равной степени"
        }), " воспользоваться его преобразующей силой. Это требует достаточных ", _jsx(HighlightByTheme, {
          theme: "finance",
          children: "ресурсов"
        }), ",особенно для охвата тех, кто нуждается в дополнительной поддержке."]
      })]
    }), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["В 2015 г. международное сообщество включило цель в области образования – ", _jsx(_components.a, {
          href: "https://sustainabledevelopment.un.org/sdg4",
          children: "ЦУР 4"
        }), "– в число 17 целей в области устойчивого развития, которые необходимо достичь к 2030 г. С тех пор были ", _jsx(PageLink, {
          name: "indicators",
          children: "разработаны рамки"
        }), " для мониторинга прогресса в решении задач, поставленных в этой цели. На этом сайте обобщены основные факты и тенденции в области образования во всем мире по пяти темам."]
      })
    }), "\n", _jsx(ThemeLinks, {}), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["Он дополняет информацию, содержащуюся в печатном варианте ", _jsx(_components.a, {
          href: "https://ru.unesco.org/gem-report/allreports",
          children: "Всемирного доклада по мониторингу образования"
        }), ", который является инструментом международного сообщества для мониторинга деятельности и обзора прогресса в достижении нашей цели в области образования – ЦУР 4."]
      })
    }), "\n", _jsx(LandingButton, {
      children: "Начать читать"
    }), "\n", _jsx(RelatedContent, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
